import { enableDebugTools } from '@angular/platform-browser';
import { ApplicationInitStatus, ApplicationRef, enableProdMode } from '@angular/core';

export function runApplication({
  bootstrapFn,
  isProduction
}: {
  bootstrapFn: () => Promise<ApplicationRef>;
  isProduction?: boolean;
}): void {
  if (isProduction) {
    enableProdMode();
  }

  document.addEventListener('DOMContentLoaded', () => {
    bootstrapFn()
      .then(appRef => {
        if (!isProduction) {
          const appComp = appRef.components[0];
          enableDebugTools(appComp);
        }
        return appRef;
      })
      .then(appRef => {
        const initStatus = appRef.injector.get(ApplicationInitStatus);
        return initStatus ? initStatus.donePromise : true;
      })
      // eslint-disable-next-line no-console
      .catch(err => console.error(err))
      .finally(() => {
        const appOpener = document.querySelector('.app-opener');
        if (appOpener) {
          // TODO remove once app.module won't be so huge
          setTimeout(() => {
            appOpener.parentElement.removeChild(appOpener);
          }, 100);
        }
      });
  });
}
